"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var DEFAULT_PROPS = {
  resourceType: 'CookieConsent_1_0_0',
  mainHeading: 'A better experience',
  paragraph: '<p>Integer rhoncus pulvinar congue. Duis sed molestie metus, eu interdum erat. Etiam bibendum, tellus facilisis vehicula pharetra, mi nisl ullamcorper velit, quis feugiat lectus nulla vitae mi. <a href="#">Inline link to policy and privacy policy</a></p>',
  link: {
    url: '#',
    label: 'Accept & Close'
  }
};
var _default = DEFAULT_PROPS;
exports["default"] = _default;